// This file was generated by svgr, do not edit it.
import * as React from 'react'
import { clsx } from 'clsx'
import styles from '../Icon.module.css'
import {
  computeStrokeWidth,
  computeSize,
  getIconColorClassName,
} from '../helpers'
import type { IconProps, IconComponentRef } from '../helpers'
const WhatsappIcon = React.forwardRef(
  (
    { size, stroke, className, color, ...props }: IconProps,
    ref: IconComponentRef,
  ) => {
    const iconName = 'whatsapp'
    const computedSize = computeSize(size)
    const computedStrokeWidth = computeStrokeWidth(computedSize, stroke)
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={clsx(className, styles.base, getIconColorClassName(color))}
        data-icon={iconName}
        aria-hidden="true"
        strokeWidth={computedStrokeWidth}
        width={computedSize}
        height={computedSize}
        ref={ref}
        {...props}
      >
        <path
          d="M16.5817 13.985C16.333 13.8608 15.1097 13.2625 14.882 13.1792C14.6534 13.0967 14.4876 13.0558 14.321 13.3042C14.156 13.5517 13.6788 14.1092 13.5339 14.2742C13.3891 14.44 13.2434 14.46 12.9947 14.3367C12.746 14.2117 11.9439 13.9508 10.9935 13.1075C10.2542 12.4509 9.75431 11.64 9.60946 11.3917C9.46461 11.1442 9.59439 11.01 9.71831 10.8867C9.83051 10.7759 9.96783 10.5975 10.0918 10.4534C10.2165 10.3084 10.2575 10.205 10.3413 10.0392C10.4242 9.87419 10.3831 9.73002 10.3203 9.60585C10.2575 9.48169 9.76018 8.26252 9.55336 7.76669C9.35073 7.28419 9.14559 7.35003 8.9932 7.34169C8.84835 7.33503 8.68256 7.33336 8.51594 7.33336C8.35015 7.33336 8.08053 7.39503 7.85279 7.64336C7.62504 7.89086 6.98199 8.49002 6.98199 9.70919C6.98199 10.9275 7.87372 12.105 7.99764 12.2709C8.1224 12.4359 9.75264 14.9375 12.2487 16.01C12.8423 16.265 13.3053 16.4175 13.6671 16.5308C14.2632 16.72 14.8058 16.6933 15.2337 16.6292C15.7118 16.5583 16.7057 16.03 16.9133 15.4517C17.121 14.8733 17.121 14.3775 17.0582 14.2742C16.9962 14.1708 16.8312 14.1092 16.5817 13.985ZM12.0418 20.1542H12.0385C10.5563 20.1543 9.10128 19.7577 7.82599 19.0058L7.52372 18.8275L4.39135 19.6458L5.22699 16.6058L5.03022 16.2942C4.20165 14.9811 3.76332 13.4614 3.76588 11.9109C3.76672 7.36919 7.48018 3.6742 12.0452 3.6742C14.2557 3.6742 16.3339 4.53253 17.8963 6.08919C18.6672 6.85304 19.2782 7.76146 19.694 8.76189C20.1098 9.76232 20.3221 10.8349 20.3186 11.9175C20.3161 16.4592 16.6035 20.1542 12.0418 20.1542ZM19.0861 4.9067C18.1636 3.98247 17.0659 3.24965 15.8567 2.7507C14.6475 2.25175 13.3508 1.9966 12.0418 2.00003C6.55328 2.00003 2.08624 6.44586 2.08373 11.91C2.08373 13.6567 2.54174 15.3617 3.41338 16.8642L2 22L7.27923 20.6217C8.73916 21.4133 10.3751 21.8281 12.0377 21.8283H12.0418C17.5296 21.8283 21.9974 17.3825 22 11.9175C22.004 10.6152 21.7486 9.32511 21.2484 8.12172C20.7483 6.91833 20.0133 5.82559 19.0861 4.9067Z"
          fill="currentColor"
        />
      </svg>
    )
  },
)
WhatsappIcon.displayName = 'WhatsappIcon'
export { WhatsappIcon }
